import { FormControl, TextField } from "@mui/material";
import { default as React, useEffect } from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      marginLeft: 0,
      marginRight: 0,
      width: "100%",
    },
  })
);

export interface Form0x27800000 {
  chipID: string;
}

export function Command0x27800000(props) {
  const classes = useStyles();
  const { value, handleChange } = props;

  const commandForm = {
    chipID: "",
  };

  const [fields, setFields] = React.useState<Form0x27800000>(commandForm);

  const handleChangeField =
    (prop: keyof Form0x27800000) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleChange(JSON.stringify({ ...fields, [prop]: event.target.value }));
    };

  useEffect(() => {
    const params = JSON.parse(value);

    if (!params.chipID) {
      params.chipID = "";
    }

    setFields(params);
  }, [value]);

  return (
    <>
      <FormControl className={classes.formControl}>
        <TextField
          id="chipID"
          label="ID чипа (для сверки)"
          margin="dense"
          fullWidth
          value={fields.chipID}
          onChange={handleChangeField("chipID")}
        />
      </FormControl>
    </>
  );
}
